import {NgModule} from '@angular/core';
import {SharedModule} from '@ecip/shared';
import {SystemRoutingModule} from './system-routing.module';
import {SystemResourceComponent} from './resource/resource.component';
import {SystemResourceEditComponent} from './resource/edit/edit.component';
import {SystemResourceViewComponent} from './resource/view/view.component';
import {SystemDictComponent} from './dict/dict.component';
import {SystemDictEditComponent} from './dict/edit/edit.component';
import {SystemDictViewComponent} from "./dict/view/view.component";


const COMPONENTS = [
  SystemResourceComponent,
  SystemDictComponent,
];
const COMPONENTS_NOROUNT = [
  SystemResourceEditComponent,
  SystemResourceViewComponent,
  SystemDictEditComponent,
  SystemDictViewComponent,
];

@NgModule({
  imports: [
    SharedModule,
    SystemRoutingModule
  ],
  declarations: [
    ...COMPONENTS,
    ...COMPONENTS_NOROUNT,
  ],
  entryComponents: COMPONENTS_NOROUNT
})
export class SystemModule { }
